import {
    apiGetRequest,
    apiPostRequest,
} from "../utils/webrequests";
import { EventInfo, EventsListItem } from "../data/eventInfo";
import { SessionInfo } from "../data/SessionData";

export async function getEventInfo(): Promise<EventsListItem[]> {
    try {
        const data: EventsListItem[] | undefined = await apiGetRequest("GetEventsList", null);

        if (!data) {
            throw new Error('No data received from API');
        }

        // PATCH MISSING FIELD (until backend adds it)
        return data.map(event => ({
            ...event,
            RegisteredUserCount: event.RegisteredUserCount ?? 0
        }));
    } catch (error: any) {
        throw new Error('Error fetching event info: ' + error.message);
    }
}

export async function saveEventInfo(eventInfo: Partial<EventInfo>): Promise<any> {
    try {
        await apiPostRequest("SaveEvent", eventInfo);
    } catch (error: any) {
        throw new Error('Error updating event info: ' + error.message);
    }
}

export async function deleteEventInfo(eventInfo: Partial<EventsListItem>): Promise<any> {
    try {
       const data = await apiPostRequest("RemoveEvent", eventInfo);
       return data;
    } catch (error: any) {
        throw new Error('Error deleting event info: ' + error.message);
    }
}

export async function getEventById(CurrentId: string): Promise<EventInfo>{
    try{
        const data: EventInfo = await apiGetRequest("GetEventById?id=" + CurrentId, null);
        return data;
    }catch(error: any){
        throw new Error('Error fetching event info by id: ' + error.message);
    }
}

export async function getEventSessionsByEventId(EventId:string): Promise<SessionInfo[]> {
    try{
        const data: SessionInfo[] = await apiGetRequest("GetSessions?eventId=" + EventId, null);
        return data;
    }catch(error: any){
        throw new Error('Error fetching event session info by id: ' + error.message);
    }
}